// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/altitude-selection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/altitude-selection/altitude-selection.js';
import g1 from '../lessons/navigation/altitude-selection/range-endurance-planning.js';

mount([g0, g1]);
